import Color from '@bootstrap-styled/color';

const brandColors = {
    $white: '#ffffff',
    $black: '#000000',

    $red: '#C43523',
    $brown: '#614C55',
    $border: '#D8D8D8',
    $dark: '#1B1A33',
    $muted: '#AAAAAA',
};

export { brandColors };

const colors = {

    $oceanblue: '#015271',
    $blue: '#04203A',
    $pink: '#5F043F',
    $green: '#005356',
    $purple: '#422449',
    $gold: '#B1956A',
    $maroon: '#5A0015',

    $brown: brandColors.$brown,
    $dark: brandColors.$dark,
    $muted: brandColors.$muted,
    $black: '#000000',
    $white: '#ffffff',
    $red: '#960003',
    $contrast: '#F7F7F7',
    '$contrast-darker': '#dedede',
    '$contrast-lighter': '#fcfcfc',
};

colors['$body-bg'] = colors.$white;
colors['$brand-primary'] = colors.$dark;
colors['$brand-danger'] = colors.$red;

colors['$link-color'] = colors['$brand-dark'];
colors['$link-decoration'] = 'underline';
colors['$link-hover-color'] = Color(colors['$link-color']).lighten(0.40).toString();
colors['$link-hover-decoration'] = 'underline';


export default colors;
